import React from "react";
import "./Contact.css";
import { Badge, Avatar } from "@material-ui/core";

function Contact({ image, name, online }) {
  return (
    <div className="contact">
      <Badge
        badgeContent=" "
        overlap="circle"
        variant="dot"
        color={online ? "primary" : "error"}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Avatar className="contact__avatar" src={image} alt={name} />
      </Badge>
      {name}
    </div>
  );
}

export default Contact;
